<template>
    <v-app dark>
        <v-content>
            <v-container fill-height row>
                <v-layout align-center justify-end row fill-height>
                    <v-flex style="float: right; position: absolute">
                        <div class="text-xs-right">
                            <iframe title="Anchor.fm Frame" src="https://anchor.fm/unconventional-geek/embed"
                                    height="102px" width="400px" frameborder="0" scrolling="no"></iframe>
                        </div>
                        <v-img
                                :src="require('./assets/Logo_White_BG_transparent.svg')"
                                contain
                                max-width="400px"
                                min-width="200px"
                                width="400px"
                        >
                            <!--<v-layout align-end justify-end column fill-height class="pr-3 pb-3">-->
                            <v-layout align-start justify-end column fill-height class="pl-3 pb-3">
                                <div class="display-1 font-weight-thin text-xs-left">
                                    A Podcast
                                </div>
                                <span class="subheading font-weight-thin text-xs-right">
                                by Karlan Bousquet
                            </span>
                            </v-layout>
                        </v-img>


                        <div class="text-xs-right">
                            <v-layout align-center justify-end row fill-height>
                                <v-btn icon :disabled="firstPlatform"
                                       @click="((firstPlatform = !firstPlatform)(secondPlatform = !secondPlatform))">
                                    <v-icon :disabled="firstPlatform">fas fa-chevron-left</v-icon>
                                </v-btn>
                                <span transition="slide-x-transition">
                                <v-btn v-show="firstPlatform" icon small v-for="(platform,p) in listenPodcast"
                                       :key="'platform-' + p" :href="platform.url" target="_blank">
                                    <v-img :src="require('./assets/podcast/' + platform.image + '.png')" height="32px"
                                           width="32px"></v-img>
                                </v-btn>
                                </span>
                                <span transition="slide-x-reverse-transition">

                                    <v-btn v-show="secondPlatform" icon small v-for="(platform,p2) in listenPodcast2"
                                           :key="'platform2-'+ p2" :href="platform.url" target="_blank">
                                    <v-img :src="require('./assets/podcast/' + platform.image + '.png')" height="32px"
                                           width="32px"></v-img>
                                </v-btn>
                                </span>
                                <v-btn icon :disabled="secondPlatform"
                                       @click="((firstPlatform = !firstPlatform)(secondPlatform = !secondPlatform))">
                                    <v-icon :disabled="secondPlatform">fas fa-chevron-right</v-icon>
                                </v-btn>
                            </v-layout>
                        </div>
                        <div class="text-xs-right">
                          <span v-for="(social,s) in socials" :key="s">
                            <v-btn icon :href="social.url" target="_blank">
                                <v-icon large>fab fa-{{ social.icon }}</v-icon>
                            </v-btn>
                          </span>
                        </div>
                    </v-flex>
                </v-layout>
            </v-container>
            <!--<HelloWorld/>-->
        </v-content>
    </v-app>
</template>

<script>
    // import HelloWorld from './components/HelloWorld'

    export default {
        name: 'App',
        data() {
            return {
                firstPlatform: true,
                secondPlatform: false,
                listenPodcast: [
                    {name: "Anchor.fm", url: "https://anchor.fm/unconventional-geek", image: "anchor"},
                    {name: "Pocket Casts", url: "https://pca.st/lMO0", image: "pocket_casts"},
                    {
                        name: "Apple Podcasts",
                        url: "https://itunes.apple.com/us/podcast/unconventional-geek/id1441706911",
                        image: "apple_podcasts"
                    },
                    {
                        name: "Google Podcasts",
                        url: "https://www.google.com/podcasts?feed=aHR0cHM6Ly9hbmNob3IuZm0vcy80NTNlZDRjL3BvZGNhc3QvcnNz",
                        image: "google_podcasts_outline"
                    },
                    {name: "Spotify", url: "https://open.spotify.com/show/0Vyb7JWYK2nM50yhCqHeyR", image: "spotify"},
                ],
                listenPodcast2: [
                    {
                        name: "Stitcher",
                        url: "https://www.stitcher.com/podcast/anchor-podcasts/unconventional-geek",
                        image: "stitcher"
                    },
                    {name: "Breaker", url: "https://www.breaker.audio/unconventional-geek", image: "breaker"},
                    {name: "Castbox", url: "https://castbox.fm/channel/id1483316", image: "castbox"},
                    {
                        name: "Overcast",
                        url: "https://overcast.fm/itunes1441706911/unconventional-geek",
                        image: "overcast"
                    },
                    {
                        name: "Radio Public",
                        url: "https://radiopublic.com/unconventional-geek-6B35KQ",
                        image: "radiopublic"
                    },
                ],
                socials: [
                    {name: "Twitter", url: "https://twitter.com/uncongeek", icon: "twitter"},
                    {name: "Instagram", url: "https://www.instagram.com/UnconventionalGeek/", icon: "instagram"},
                    {name: "Facebook", url: "https://www.facebook.com/UnconventionalGeek/", icon: "facebook"},
                    {name: "Discord", url: "https://discord.gg/X73su4S", icon: "discord"},
                ]
            }
        }
    }
</script>
